// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAXzyI7x52EbeUjI5dL69l4yStWxqrabxU",
  authDomain: "byblearning-e399b.firebaseapp.com",
  projectId: "byblearning-e399b",
  storageBucket: "byblearning-e399b.firebasestorage.app",
  messagingSenderId: "924846153252",
  appId: "1:924846153252:web:b10cb021538bf93366c2b1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Authentication
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Firestore database
export const db = getFirestore(app);

export default app;